import React, { useEffect, useState } from 'react';
import RequestListView from './RequestListView';
import RequestDetailView from './RequestDetailView';

const RequestRateTab = ({
  setHeaderActions,
  statusFilter = 'pending',
  onStatusFilterChange = () => {},
  isStatic = false,
  source = 'admin',
  tabTitle = 'Rate Requests',
}) => {
  const [activeRequest, setActiveRequest] = useState(null);

  useEffect(() => {
    if (activeRequest) {
      setHeaderActions(
        <button type="button" className="sr-reset-btn list-tab-back-button" onClick={() => setActiveRequest(null)}>
          ‹&nbsp; Back to Requests
        </button>,
      );
    } else {
      setHeaderActions(
        <div
          className="request-rate-status-filter-wrapper"
          style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
        >
          <label
            htmlFor="request-rate-status-select"
            style={{
              margin: 0,
              fontSize: '13px',
              fontWeight: 600,
              color: '#475467',
              whiteSpace: 'nowrap',
            }}
          >
            Status:
          </label>
          <select
            id="request-rate-status-select"
            value={statusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value)}
            style={{
              height: '34px',
              minWidth: '130px',
              padding: '4px 30px 4px 12px',
              fontSize: '13px',
              fontWeight: 500,
              color: '#344054',
              backgroundColor: '#fff',
              border: '1px solid #d0d5dd',
              borderRadius: '6px',
              outline: 'none',
              cursor: 'pointer',
              boxShadow: '0 1px 2px rgba(16, 24, 40, 0.05)',
              appearance: 'none',
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23475467' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
            }}
          >
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="">All</option>
          </select>
        </div>,
      );
    }

    return () => setHeaderActions(null);
  }, [activeRequest, statusFilter, onStatusFilterChange, setHeaderActions]);

  if (activeRequest) {
    return (
      <RequestDetailView
        request={activeRequest}
        source={source}
      />
    );
  }

  return (
    <RequestListView
      statusFilter={statusFilter}
      onView={(req) => setActiveRequest(req)}
      isStatic={isStatic}
      source={source}
      tabTitle={tabTitle}
    />
  );
};

export default RequestRateTab;
